//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated by the ProcessTemplatesAfterBuild executable.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------
(function () {
    "use strict";

    angular.module("app").factory("installationRequest", InstallationRequestFactory);

    InstallationRequestFactory.$inject = ["apiClientFactory"];
    function InstallationRequestFactory(apiClientFactory) {

        const routePrefix = "api/Installation/Request/";

        return {
            Accept: apiClientFactory.patch(routePrefix + "Accept/"),
            ApproveStop: apiClientFactory.delete(routePrefix + "Stop/Approve/"),
            DenyStop: apiClientFactory.patch(routePrefix + "Stop/Deny/"),
            DownloadCertificate: apiClientFactory.getFile(routePrefix + "DownloadCertificate/"),
            Get: apiClientFactory.get(routePrefix),
            GetDeclarationOfConformity: apiClientFactory.getFile(routePrefix + "DeclarationOfConformity/"),
            GetNew: apiClientFactory.get(routePrefix + "New/"),
            RecallRequest: apiClientFactory.patch(routePrefix + "Recall/"),
            ReopenScreenings: apiClientFactory.patch(routePrefix + "ReopenScreenings/"),
            Save: apiClientFactory.put(routePrefix + "Save/"),
            SaveRemark: apiClientFactory.put(routePrefix + "SaveRemark/"),
            SaveZones: apiClientFactory.put(routePrefix + "SaveZones/"),
            Search: apiClientFactory.post(routePrefix + "Search/"),
            SendBack: apiClientFactory.patch(routePrefix + "SendBack/"),
            StartRenewal: apiClientFactory.post(routePrefix + "StartRenewal/"),
            Stop: apiClientFactory.patch(routePrefix + "Stop/"),
            Submit: apiClientFactory.patch(routePrefix + "Submit/"),
        };
    }
})();
